import { useLazyQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { PostForm } from "./form";
import { Post as PostType } from "../../../__generated__/graphql";
import { GET_POST } from "../graphql";
import { LoadingOverlay } from "../../../components/Loading";

const Post = () => {
  const [getPost, { data, error, loading }] = useLazyQuery(GET_POST);
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    getPost({ variables: { id: id } });
  }, [id]);
  
  const isLoading = id !== undefined && !data?.post || loading
  
  return (
    <LoadingOverlay loading={isLoading}>
      <PostForm post={data?.post as PostType} />
    </LoadingOverlay>
  );
};

export default Post;
